import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PoDetail } from "@/features/purchase-orders/PoDetail";

export const Route = createFileRoute("/_authenticated/purchase-orders/$poId/")({
  component: PoDetailPage,
});

function PoDetailPage() {
  const navigate = useNavigate();
  const { poId } = Route.useParams();
  return (
    <div className="mx-auto max-w-6xl space-y-4">
      <Button variant="ghost" size="sm" onClick={() => navigate({ to: "/purchase-orders" })}><ArrowLeft className="mr-1 h-4 w-4" />Back</Button>
      <PoDetail id={poId} />
    </div>
  );
}
